import React from "react";
import { TextField } from "@material-ui/core";
import { Field, FormikProps, FieldProps } from "formik";
import { Values } from "Tools/Values";
import styled from "styled-components";
import { FileCopy, Visibility } from "@material-ui/icons";
import { Toast } from "@src/Tools/Toast";

export const STTextField = styled(TextField)`
  && {
    margin-top: 10px;
  }
`;

export const CopyButton = styled(FileCopy)`
  && {
    position: absolute;
    margin-top: 5px;
    margin-left: -22px;
    background: #fff;
    color: #444;
    cursor: pointer;
    padding-left: 5px;
  }
`;

export const ShowButton = styled(Visibility)`
  && {
    position: absolute;
    margin-top: 5px;
    margin-left: -22px;
    background: #fff;
    color: #444;
    cursor: pointer;
    padding-left: 5px;
  }
`;

export default function <T>(
  name: keyof T,
  labelKey: string,
  formikProps: FormikProps<T>,
  isEdit: boolean = true,
  onClick: any = null,
  showCopyButton: boolean = false,
  type: string = "text"
) {
  let textField: any = null;
  function copyCodeToClipboard() {
    let el = textField.children[1].children[0];
    let disabled = el.disabled;
    if (disabled) el.disabled = false;
    el.select();
    document.execCommand("copy");
    el.setSelectionRange(0, 0);
    if (disabled) el.disabled = true;
    const toast = new Toast();
    toast.showSuccess(Values.getLocalizationValue("valueHasBeenCopiedToYourClipboard"));
  }

  function showFieldHiddenContent() {
     let el = textField.children[1].children[0];
     if (el.type == "password") {
        el.type = "text";
     } else {
        el.type = "password";
     }
   }

  function renderCopyButton() {
    return showCopyButton ? (
    <CopyButton onClick={() => copyCodeToClipboard()} />
    ) : null;
  }
  function renderShowButton() {
    return type == "password" ? (
    <ShowButton onClick={() => showFieldHiddenContent()} />
    ) : null;
  }

  return (
    <Field
      name={name}
      render={({ field }: FieldProps) => (
        <span>
            <STTextField
              {...field}
              fullWidth
              label={Values.getLocalizationValue(labelKey)}
              error={formikProps.touched[name] && !!formikProps.errors[name]}
              helperText={formikProps.touched[name] && formikProps.errors[name]}
              disabled={!isEdit}
              onClick={onClick}
              ref={(tf: any) => textField = tf}
              type= {type}
            />
            {renderCopyButton()}
            {renderShowButton()}
        </span>
      )}
    />
  );
}
